import { CSSObject } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

const useBannerStyles = () => {
    const { blue700, blue800, blue900, gray900 } = colors;

    const generalStyles: CSSObject = {
        color: gray900,
        fontSize: "14px",
        fontWeight: "500",
        lineHeight: "20px",
        letterSpacing: "0.1px",

        "p, ol": {
            margin: "0"
        },

        ul: {
            padding: "revert"
        },

        li: {
            listStyle: "revert"
        },

        a: {
            color: blue700,
            cursor: "pointer",
            transition: "color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",

            "&:hover": {
                color: blue800
            },

            "&:active": {
                color: blue900
            }
        }
    };

    return { generalStyles };
};

export { useBannerStyles };
